module.exports = __webpack_public_path__ + "7d088296/img/placeholder.888fcd0b.svg";